"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _SectionCalculator = require("./SectionCalculator");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('@svgdotjs/svg.js'),
  SVG = _require.SVG,
  registerWindow = _require.registerWindow;
if (typeof window === 'undefined') {
  var _require2 = require('svgdom'),
    createSVGWindow = _require2.createSVGWindow;
  var _window = createSVGWindow();
  var document = _window.document;
  // register window and document
  registerWindow(_window, document);
}
var SVGDamagePreview = /*#__PURE__*/function () {
  function SVGDamagePreview() {
    _classCallCheck(this, SVGDamagePreview);
    _defineProperty(this, "colors", ['#77C4E9', '#A6398C', '#006C31', '#301B7A']);
    _defineProperty(this, "overlays", 0);
    _defineProperty(this, "overlay", {
      1: undefined,
      2: undefined,
      3: undefined
    });
    _defineProperty(this, "pixelX", 300);
    _defineProperty(this, "pixelY", 300);
    _defineProperty(this, "poleRadiusPx", this.pixelX / 2);
    _defineProperty(this, "diameter", 0);
    _defineProperty(this, "__stringify", function () {
      for (var _len = arguments.length, strings = new Array(_len), _key = 0; _key < _len; _key++) {
        strings[_key] = arguments[_key];
      }
      return strings.reduce(function (path, string) {
        return path += " ".concat(string);
      }, "");
    });
    this.__resetOverlay(1);
    this.__resetOverlay(2);
    this.__resetOverlay(3);
  }
  _createClass(SVGDamagePreview, [{
    key: "getSvg",
    value: function getSvg(level) {
      return this.overlay[level].svg();
    }
  }, {
    key: "__resetOverlay",
    value: function __resetOverlay(level) {
      this.overlay[level] = SVG().viewbox(0, 0, this.pixelX, this.pixelY);
      this.overlays = 0;
    }
  }, {
    key: "__polarToCartesian",
    value: function __polarToCartesian(radius, angleInDegrees) {
      var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
      return {
        x: this.pixelX / 2 + radius * Math.cos(angleInRadians),
        y: this.pixelY / 2 + radius * Math.sin(angleInRadians)
      };
    }
  }, {
    key: "__getStartAndEndAngle",
    value: function __getStartAndEndAngle(diameter, circumferenceMissing, angle) {
      var poleCircumference = diameter * Math.PI;
      var percentCircumferenceRemaining = (poleCircumference - circumferenceMissing) / poleCircumference;
      var degreesMissing = 360 - percentCircumferenceRemaining * 360;
      var startAngle = angle - degreesMissing / 2;
      var endAngle = angle + degreesMissing / 2;
      return {
        startAngle: startAngle,
        endAngle: endAngle
      };
    }
  }, {
    key: "__toRadians",
    value: function __toRadians(angle) {
      return (90 - angle) / 180 * Math.PI;
    }
  }, {
    key: "drawSection",
    value: function drawSection(level, _ref) {
      var _this = this;
      var damages = _ref.damages,
        diameter = _ref.diameter;
      this.__resetOverlay(level);
      this.diameter = diameter;
      damages.forEach(function (damage) {
        switch (damage.type) {
          case _SectionCalculator.TYPE_SHELL:
            _this.generateShellSvg(damage, level, _this.diameter);
            break;
          case _SectionCalculator.TYPE_HEART:
            _this.generateHeartSvg(damage, level, _this.diameter);
            break;
          case _SectionCalculator.TYPE_POCKET:
            _this.generatePocketSvg(damage, level, _this.diameter);
            break;
          case _SectionCalculator.TYPE_WEDGE:
            _this.generateWedgeSvg(damage, level, _this.diameter);
            break;
          case _SectionCalculator.TYPE_SECTION:
            _this.generateSectionSvg(damage, level, _this.diameter);
            break;
          case _SectionCalculator.TYPE_SLICE:
            _this.generateSliceSvg(damage, level, _this.diameter);
            break;
          case _SectionCalculator.TYPE_BOLT:
            _this.generateBoltSvg(damage, level, _this.diameter);
            break;
          case _SectionCalculator.TYPE_CAVITY:
            _this.generateCavitySvg(damage, level, _this.diameter);
            break;
          default:
            break;
        }
        _this.overlays++;
      });
      return this.svg;
    }
  }, {
    key: "generateHeartSvg",
    value: function generateHeartSvg(_ref2, level, diameter) {
      var shellThickness = _ref2.shellThickness;
      var damageToDiameterRatio = (diameter - shellThickness * 2) / diameter;
      var circleWidthInPixels = this.pixelX * damageToDiameterRatio;
      this.overlay[level].circle(circleWidthInPixels).attr({
        fill: this.colors[this.overlays],
        cx: this.poleRadiusPx,
        cy: this.poleRadiusPx
      });
    }
  }, {
    key: "generateShellSvg",
    value: function generateShellSvg(_ref3, level, diameter) {
      var damageDepth = _ref3.damageDepth;
      var shellWidth = damageDepth / diameter * this.pixelX;
      this.overlay[level].circle(this.pixelX - shellWidth).stroke({
        width: shellWidth,
        color: this.colors[this.overlays]
      }).attr({
        fill: 'transparent',
        cx: this.poleRadiusPx,
        cy: this.poleRadiusPx
      });
    }
  }, {
    key: "generatePocketSvg",
    value: function generatePocketSvg(_ref4, level, diameter) {
      var shellThickness = _ref4.shellThickness,
        pocketDiameter = _ref4.pocketDiameter,
        angleToMinShell = _ref4.angleToMinShell;
      var poleRadius = diameter / 2;
      var pocketRadius = poleRadius - shellThickness - pocketDiameter / 2;
      pocketRadius = pocketRadius / poleRadius * this.poleRadiusPx;
      var theta = this.__toRadians(angleToMinShell); // find the spot where the pocket resides in radians
      var pocketCX = Math.cos(theta) * pocketRadius + this.pixelY / 2; // find the x and y value of the center of where the pocket is supposed to begin
      var pocketCY = this.pixelY / 2 - Math.sin(theta) * pocketRadius; //
      var circleWidthInPixels = pocketDiameter / diameter * this.pixelX; //find the width of the pocket in px
      this.overlay[level].circle(circleWidthInPixels) // circ takes in a diameter
      .attr({
        fill: this.colors[this.overlays],
        cx: pocketCX,
        // set the starting point
        cy: pocketCY
      });
    }
  }, {
    key: "generateWedgeSvg",
    value: function generateWedgeSvg(_ref5, level, diameter) {
      var angleToDamage = _ref5.angleToDamage,
        circumferenceMissing = _ref5.circumferenceMissing,
        depthMissing = _ref5.depthMissing;
      var poleRadius = diameter / 2;
      var _this$__getStartAndEn = this.__getStartAndEndAngle(diameter, circumferenceMissing, angleToDamage),
        startAngle = _this$__getStartAndEn.startAngle,
        endAngle = _this$__getStartAndEn.endAngle;
      var centerRadius = (poleRadius - depthMissing) / poleRadius * this.poleRadiusPx;
      var angleToDamageRads = this.__toRadians(angleToDamage);
      var outerStart = this.__polarToCartesian(this.poleRadiusPx, endAngle);
      var outerEnd = this.__polarToCartesian(this.poleRadiusPx, startAngle);
      var centerX = centerRadius * Math.cos(angleToDamageRads) + this.poleRadiusPx;
      var centerY = this.poleRadiusPx - centerRadius * Math.sin(angleToDamageRads);
      var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
      var path = this.__stringify('M', outerStart.x, outerStart.y, 'A', this.poleRadiusPx, this.poleRadiusPx, '0', largeArcFlag, '0', outerEnd.x, outerEnd.y, 'L', centerX, centerY, 'L', outerStart.x, outerStart.y, 'Z');
      this.overlay[level].path(path).attr({
        fill: this.colors[this.overlays]
      });
    }
  }, {
    key: "generateSectionSvg",
    value: function generateSectionSvg(_ref6, level, diameter) {
      var angleToOpening = _ref6.angleToOpening,
        circumferenceMissing = _ref6.circumferenceMissing,
        depthMissing = _ref6.depthMissing,
        shellThickness = _ref6.shellThickness;
      var shellThicknessPx = shellThickness / diameter * this.pixelX;
      var sectionRadius = depthMissing / diameter * this.pixelX;
      var _this$__getStartAndEn2 = this.__getStartAndEndAngle(diameter, circumferenceMissing, angleToOpening),
        startAngle = _this$__getStartAndEn2.startAngle,
        endAngle = _this$__getStartAndEn2.endAngle;
      var outerStart = this.__polarToCartesian(this.poleRadiusPx - shellThicknessPx, endAngle);
      var outerEnd = this.__polarToCartesian(this.poleRadiusPx - shellThicknessPx, startAngle);
      var innerStart = this.__polarToCartesian(this.poleRadiusPx - sectionRadius, startAngle);
      var innerEnd = this.__polarToCartesian(this.poleRadiusPx - sectionRadius, endAngle);
      var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
      var path = this.__stringify('M', outerStart.x, outerStart.y, 'A', this.poleRadiusPx, this.poleRadiusPx, '0', largeArcFlag, '0', outerEnd.x, outerEnd.y, 'L', innerStart.x, innerStart.y, 'A', this.poleRadiusPx, this.poleRadiusPx, '0', largeArcFlag, '1', innerEnd.x, innerEnd.y, 'L', outerStart.x, outerStart.y, 'Z');
      this.overlay[level].path(path).attr({
        fill: this.colors[this.overlays]
      });
    }
  }, {
    key: "generateSliceSvg",
    value: function generateSliceSvg(_ref7, level, diameter) {
      var angleToDamage = _ref7.angleToDamage,
        depthMissing = _ref7.depthMissing,
        widthMissing = _ref7.widthMissing;
      var poleRadius = diameter / 2;
      if (depthMissing) {
        var xx = poleRadius - depthMissing;
        widthMissing = 2 * Math.sqrt(poleRadius * poleRadius - xx * xx);
      }
      var degreesMissing = 2 * Math.asin(widthMissing / diameter) * (180 / Math.PI);
      var startAngle = angleToDamage - degreesMissing / 2;
      var endAngle = angleToDamage + degreesMissing / 2;
      var start = this.__polarToCartesian(this.poleRadiusPx, endAngle);
      var end = this.__polarToCartesian(this.poleRadiusPx, startAngle);
      var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
      var path = this.__stringify('M', start.x, start.y, 'A', this.poleRadiusPx, this.poleRadiusPx, '0', largeArcFlag, '0', end.x, end.y, 'L', start.x, start.y, 'Z');
      this.overlay[level].path(path).attr({
        fill: this.colors[this.overlays]
      });
    }
  }, {
    key: "generateBoltSvg",
    value: function generateBoltSvg(_ref8, level, diameter) {
      var angleToOpening = _ref8.angleToOpening,
        holeDiameter = _ref8.holeDiameter;
      var poleCircumference = diameter * Math.PI;
      var degreesMissing = holeDiameter / poleCircumference * 360;
      var startAngle = angleToOpening - degreesMissing / 2;
      var endAngle = angleToOpening + degreesMissing / 2;
      var outerStart = this.__polarToCartesian(this.poleRadiusPx, endAngle);
      var outerEnd = this.__polarToCartesian(this.poleRadiusPx, startAngle);
      var innerStart = this.__polarToCartesian(this.poleRadiusPx, endAngle + 180);
      var innerEnd = this.__polarToCartesian(this.poleRadiusPx, startAngle + 180);
      var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
      var path = this.__stringify('M', outerStart.x, outerStart.y, 'A', this.poleRadiusPx, this.poleRadiusPx, ' 0 ', largeArcFlag, ' 0 ', outerEnd.x, outerEnd.y, 'L', innerStart.x, innerStart.y, 'A', this.poleRadiusPx, this.poleRadiusPx, ' 0 ', largeArcFlag, ' 0 ', innerEnd.x, innerEnd.y, 'Z');
      this.overlay[level].path(path).attr({
        fill: this.colors[this.overlays]
      });
    }
  }, {
    key: "generateCavitySvg",
    value: function generateCavitySvg(_ref9, level, diameter) {
      var angleToOpening = _ref9.angleToOpening,
        circumferenceMissing = _ref9.circumferenceMissing,
        shellThicknessAtOpening = _ref9.shellThicknessAtOpening,
        nestDiameter = _ref9.nestDiameter;
      var poleRadius = diameter / 2;
      var depthMissing = nestDiameter / 2 + shellThicknessAtOpening;
      var sectionRadius = depthMissing / diameter * this.pixelX;
      var _this$__getStartAndEn3 = this.__getStartAndEndAngle(diameter, circumferenceMissing, angleToOpening),
        startAngle = _this$__getStartAndEn3.startAngle,
        endAngle = _this$__getStartAndEn3.endAngle;
      var nestWidthPx = nestDiameter / poleRadius * this.poleRadiusPx;
      var centerRadius = (poleRadius - depthMissing) / poleRadius * this.poleRadiusPx;
      var angleTodamageRads = this.__toRadians(angleToOpening);
      var centerX = centerRadius * Math.cos(angleTodamageRads) + this.poleRadiusPx;
      var centerY = this.poleRadiusPx - centerRadius * Math.sin(angleTodamageRads);
      var outerStart = this.__polarToCartesian(this.poleRadiusPx, endAngle);
      var outerEnd = this.__polarToCartesian(this.poleRadiusPx, startAngle);
      var innerStart = this.__polarToCartesian(this.poleRadiusPx - sectionRadius, startAngle);
      var innerEnd = this.__polarToCartesian(this.poleRadiusPx - sectionRadius, endAngle);
      var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
      var path = this.__stringify('M', outerStart.x, outerStart.y, 'A', this.poleRadiusPx, this.poleRadiusPx, '0', largeArcFlag, '0', outerEnd.x, outerEnd.y, 'L', innerStart.x, innerStart.y, 'A', this.poleRadiusPx, this.poleRadiusPx, '0', largeArcFlag, '1', innerEnd.x, innerEnd.y, 'L', outerStart.x, outerStart.y, 'Z');
      this.overlay[level].path(path).attr({
        fill: this.colors[this.overlays]
      });
      this.overlay[level].circle(nestWidthPx).attr({
        cx: centerX,
        cy: centerY,
        fill: this.colors[this.overlays]
      });
    }
  }]);
  return SVGDamagePreview;
}();
var _default = exports["default"] = SVGDamagePreview;